import createReactComponent from '../createReactComponent';
export default createReactComponent('circle-letter-l', 'IconCircleLetterL', [
  ['path', { d: 'M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0', key: 'svg-0' }],
  ['path', { d: 'M10 8v8h4', key: 'svg-1' }],
]);
